<script>
    import {tagAddInList, tagRemoveInList} from '@/scripts/tag.js';
    import TagContainer from '@/components/base-components/TagContainer.vue';

    export default {
        data() {
            return {
                tagValue: '',
            }
        },
        components: {
            TagContainer: TagContainer,
        },
        computed: {
            replaceTag() { return this.$store.getters.MULTI_EDIT_REPLACE_TAG },
            addTagArray() { return this.$store.getters.MULTI_EDIT_ADD_TAG },
            removeTagArray() { return this.$store.getters.MULTI_EDIT_REMOVE_TAG },
        },
        methods: {
            async setReplace(event) {
                await this.$store.commit('MULTI_EDIT_REPLACE_TAG', event.target.checked);
            },
            async addTag(isAdd) {
                let newSelectTag = await tagAddInList(isAdd === true ? this.addTagArray : this.removeTagArray, this.tagValue);
                this.tagValue = '';
                await this.$store.commit(isAdd === true ? 'MULTI_EDIT_ADD_TAG' : 'MULTI_EDIT_REMOVE_TAG', newSelectTag);
            },
            async removeTag(event, isAdd) {
                let newSelectTag = await tagRemoveInList(isAdd === true ? this.addTagArray : this.removeTagArray, event);
                await this.$store.commit(isAdd === true ? 'MULTI_EDIT_ADD_TAG' : 'MULTI_EDIT_REMOVE_TAG', newSelectTag);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Tags:</label>
        <label>
            <input 
                type="checkbox" 
                class="mt_5 mb_10"
                v-model="replaceTag"
                @change="setReplace"
            >
            Replace value
        </label>

        <div class="left_sub_multi_container">
            <input 
                type="text" 
                v-model="tagValue" 
                list="tagList"
                class="right_input"
            >
            <button
                class="button_blue_100 ml_10"
                @click="addTag(true)"
            >
                Add
            </button>
            <button
                class="button_blue_100 ml_10"
                @click="addTag(false)"
            >
                Remove
            </button>
        </div>

        <div class="tag_container mt_5">
            <TagContainer 
                v-for="(tagValue, tagIndex) in addTagArray" :key="tagIndex"
                tag-color="tag-add"
                :tag-i-d="tagValue"
                @deleteTag = "removeTag($event, true)"
            />
            <TagContainer 
                v-for="(tagValue, tagIndex) in removeTagArray" :key="tagIndex"
                tag-color="tag-remove"
                :tag-i-d="tagValue"
                @deleteTag = "removeTag($event, false)"
            />
        </div>
    </div>
</template>